module.exports = __webpack_public_path__ + "img/restaurantlogoblau.2661238c.png";